<div class="expansion">
  <h3 class="expansion__title">Сколько мест докупить?</h3>

  <div class="expansion__row">
    <label>Добавить пользователей</label>
    <input type="number" min="1" [(ngModel)]="addUsers">
  </div>

  <p class="expansion__hint" *ngIf="status?.expiredAt">
    До конца оплаченного периода: {{ remainingDays }} дн. Текущая скидка: {{ discount }}%.
  </p>

  <p class="expansion__total">
    К оплате сегодня: <strong>{{ total | number:undefined:'ru' }}</strong> ₽
  </p>

  <button type="button" class="button button_theme-1" (click)="submit()" [disabled]="total <= 0 || addUsers <= 0">
    <ng-container *ngIf="paymentType === 'bank_card'">Оплатить картой</ng-container>
    <ng-container *ngIf="paymentType === 'invoice'">Выставить счёт</ng-container>
    <ng-container *ngIf="paymentType === 'test'">Тестовая оплата</ng-container>
  </button>
</div>
